/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PromotionalLinkPromotionalLinkGenerateDefaultsFhirIdPost$Params {
  fhirId: string;
}

export function promotionalLinkPromotionalLinkGenerateDefaultsFhirIdPost(http: HttpClient, rootUrl: string, params: PromotionalLinkPromotionalLinkGenerateDefaultsFhirIdPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, promotionalLinkPromotionalLinkGenerateDefaultsFhirIdPost.PATH, 'post');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<string>;
    })
  );
}

promotionalLinkPromotionalLinkGenerateDefaultsFhirIdPost.PATH = '/PromotionalLink/PromotionalLink/GenerateDefaults/{fhirId}';
